// The running answer's stream id, as the server confirmed it. While a turn is
// still starting, the transport stores an early-recovery descriptor
// (`pending-turn:…`, ui/lib/early-turn-recovery.ts) in its place; a steer is
// addressed only to the confirmed id, which arrives with the response headers,
// once the server has registered the answer and its inbox.
export const PENDING_STREAM_PREFIX = 'pending-turn:';

type Live = { threadId: string; streamId: string } | null;

/** The stream id itself, also out of an early-recovery descriptor (the server answers under the same id). */
export function plainStreamId(value: string | null | undefined): string | null {
  if (!value) return null;
  if (!value.startsWith(PENDING_STREAM_PREFIX)) return value;
  try {
    const parsed = JSON.parse(decodeURIComponent(value.slice(PENDING_STREAM_PREFIX.length))) as {
      streamId?: unknown;
    };
    return typeof parsed.streamId === 'string' && parsed.streamId ? parsed.streamId : null;
  } catch {
    return null;
  }
}

export async function confirmedStreamId(
  threadId: string,
  live: () => Live,
  isRunning: () => boolean,
  { timeoutMs = 10_000, intervalMs = 150, now = Date.now } = {},
): Promise<string | null> {
  const deadline = now() + timeoutMs;
  for (;;) {
    const current = live();
    if (
      current?.threadId === threadId &&
      current.streamId &&
      !current.streamId.startsWith(PENDING_STREAM_PREFIX)
    )
      return current.streamId;
    if (!isRunning() || now() >= deadline) return null;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}
